import IfElseCase from "./IfElseCase";
import RecordCreateUpdate from "./RecordCreateUpdate";
import RecordUpdateFields from "./RecordUpdateFields";
import RecordUpdateTags from "./RecordUpdateTags";
import RecordCreateSubitems from "./RecordCreateSubitems";

const ActionConfigSection = ({ action, setAction, workflow }) => {
  switch (action?.Type) {
    case "record-create-update":
      return (
        <RecordCreateUpdate
          action={action}
          setAction={setAction}
          actions={workflow.Actions}
        />
      );
    case "record-update-tags":
      return (
        <RecordUpdateTags
          action={action}
          setAction={setAction}
          actions={workflow.Actions}
        />
      );
    case "record-update-fields":
      return (
        <RecordUpdateFields
          action={action}
          setAction={setAction}
          actions={workflow.Actions}
        />
      );
    case "if-else-case":
      return (
        <IfElseCase
          action={action}
          setAction={setAction}
          actions={workflow.Actions}
        />
      );
    case "record-create-update-subitems":
      return (
        <RecordCreateSubitems
          action={action}
          setAction={setAction}
          actions={workflow.Actions}
        />
      );
    default:
      return null;
  }
};

export default ActionConfigSection;
